/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { showToast } from "utils/helper";
import Layout from "components/layout";
import { Link, useSearchParams } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import {
  useAutocompleteCIT,
  useAutocompleteHolding,
  useGetRoutes,
} from "utils/apis/lookups.api";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { ListPlus } from "lucide-react";
import { format as formatDate } from "date-fns";
import { PREV_5_DAY_DATE } from "utils/constant";
import { useCreateB2BOrder } from "utils/apis/b2b.api";
import SearchableDropdown from "components/searchableDropdown";

const formSchema = z.object({
  jobType: z.string().min(1, { message: "Job Type is required." }),
  sourceCustomer: z.string().optional(),
  sourceCustomerName: z.string().optional(),
  sourceLocation: z
    .string()
    .min(1, { message: "Source location is required." }),
  onwardCustomer: z.string().optional(),
  onwardCustomerName: z.string().optional(),
  onwardLocation: z
    .string()
    .min(1, { message: "Onward location is required." }),
  serviceDateTime: z.date({ required_error: "Service date is required." }),
  invoicingModel: z
    .string()
    .min(1, { message: "Invoicing Model is required." }),
  priority: z.string().min(1, { message: "Job Priority is required." }),
  shift: z.string().min(1, { message: "Shift is required." }),
  jobNature: z.string(),
  requestedBy: z.string().min(1, { message: "Requested By is required." }),
  routeNo: z.string().optional(),
  remarks: z.string().optional(),
});

const jobPriorities = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];

const jobNatures = [
  { value: "Normal", name: "Normal" },
  { value: "Adhoc", name: "Adhoc" },
  { value: "Special Service", name: "Special Service" },
];

const invoicingModels = [
  { value: "Fixed", name: "Fixed" },
  { value: "Dedicated", name: "Dedicated" },
  { value: "Service", name: "Service" },
];

const jobTypes = [
  { value: "Collection", name: "Collection" },
  { value: "Holding", name: "Holding" },
  { value: "Delivery", name: "Delivery" },
];

export default function CreateB2BService() {
  const [searchParams] = useSearchParams();

  // Get the value of the 'page' parameter, defaulting to '1'
  const requestId = searchParams.get("requestId") || null;
  // display objects for request-review
  const [sourceLocation, setSourceLocation] = useState<any>(null);
  const [destinationLocation, setDestinationLocation] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [onwardSearch, setOnwardSearch] = useState("");
  const [customerId, setCustomerId] = useState("");

  // Jobs: state + canonical ref
  const [serviceJobs, setServiceJobs] = useState<any[]>([]);

  // react-hook-form
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      jobType: "",
      requestedBy: "",
      sourceCustomer: "",
      sourceCustomerName: "",
      sourceLocation: "",
      onwardLocation: "",
      onwardCustomer: "",
      onwardCustomerName: "",
      invoicingModel: "Service",
      serviceDateTime: new Date(),
      priority: "3",
      jobNature: "Normal",
      shift: "morning",
      routeNo: "",
      remarks: "",
    },
  });

  // lookups/hooks
  const { data: inRouteTeams } = useGetRoutes();
  // master site list (contains barcode and fallback details)
  const { data: sourceLocations, isFetching: isFetchingAutocomplete } =
    useAutocompleteCIT(searchTerm);

  const {
    mutate: createB2BOrder,
    isSuccess: isOrderSuccess,
    isPending: isOrderPending,
    isError: isOrderError,
    reset: orderReset,
  } = useCreateB2BOrder(requestId);

  const isHolding = form.watch("jobType") === "Holding";

  const { data: onwardLocations, isFetching: isFetchingOnward } =
    useAutocompleteCIT(isHolding ? "" : onwardSearch);
  const { data: holdingList, isFetching: isFetchingHolding } =
    useAutocompleteHolding(isHolding ? onwardSearch : "");

  // Source location selection
  const onSourceLocationChanged = (value: string) => {
    // block same as destination
    const destSpId = destinationLocation?.servicePointId;
    if (destSpId && String(destSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("sourceLocation", "");
      form.setValue("sourceCustomer", "");
      form.setValue("sourceCustomerName", "");
      setSourceLocation(null);
      return;
    }

    const selectedSP = sourceLocations?.find(
      (item: any) => item?.servicePointId === value,
    );
    if (selectedSP) {
      setSourceLocation(selectedSP);
      if (!serviceJobs?.length) {
        setCustomerId(selectedSP?.customerId);
      }
      form.setValue("sourceCustomer", selectedSP?.customerId);
      form.setValue("sourceCustomerName", selectedSP?.customer);
    }
  };

  const onDestinationLocationChanged = (value: string) => {
    const sourceSpId =
      sourceLocation?.servicePointId || form.getValues("sourceLocation");
    if (sourceSpId && String(sourceSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("onwardLocation", "");
      form.setValue("onwardCustomer", "");
      form.setValue("onwardCustomerName", "");
      setDestinationLocation(null);
      if (!serviceJobs?.length) {
        setCustomerId("");
      }
      return;
    }

    const selectedSP = (isHolding ? holdingList : onwardLocations)?.find(
      (item: any) => item?.servicePointId === value,
    );

    if (selectedSP) {
      setDestinationLocation(selectedSP);
      form.setValue("onwardCustomer", selectedSP?.customerId);
      form.setValue("onwardCustomerName", selectedSP?.customer);
    }
  };

  const addJob = (values: z.infer<typeof formSchema>) => {
    const jobNo = (serviceJobs?.length || 0) + 1;
    const job = {
      jobNo,
      requestId: requestId || `${Date.now()}-${jobNo}`,
      customerId,
      jobType: values.jobType,
      jobNature: values.jobNature,
      priority: Number(values.priority || "0"),
      routeNo: values.routeNo,
      sourceSPId:
        sourceLocation?.servicePointId || sourceLocation?.cashCenterId,
      onwardSPId:
        destinationLocation?.servicePointId || destinationLocation.cashCenterId,
      source: sourceLocation?.locationName || sourceLocation?.name,
      destination:
        destinationLocation?.locationName || destinationLocation?.name,
      shift: values.shift,
      serviceDateTime: values.serviceDateTime,
      invoicingModel: values.invoicingModel,
      containsValuables: false,
      remarks: values.remarks || "",
      requestedBy: values.requestedBy || "",
    };

    if (requestId) {
      createB2BOrder(job);
      return;
    }
    const exists = serviceJobs?.find(
      (jb: any) =>
        jb.sourceSPId === job.sourceSPId && jb.onwardSPId === job.onwardSPId,
    );
    if (exists) {
      showToast("error", "Job for same source-destination already added.");
      return;
    }

    setServiceJobs([...serviceJobs, job]);
    form.reset();
    form.setValue("requestedBy", job.requestedBy);
    form.setValue("invoicingModel", job.invoicingModel);
    setDestinationLocation(null);
    setSourceLocation(null);
    setSearchTerm("");
    setOnwardSearch("");
  };

  const deleteJob = (idx: number) => {
    const removed = serviceJobs.filter((_, i) => i !== idx);
    setServiceJobs(removed);
  };

  function findClosestJob(jobs: any[]) {
    if (!Array.isArray(jobs) || jobs.length === 0) return null;
    const currentDate = new Date();
    let closest = jobs[0];
    let minDiff = Math.abs(
      new Date(closest.serviceDateTime).getTime() - currentDate.getTime(),
    );
    for (let i = 1; i < jobs.length; i++) {
      const jobDate = new Date(jobs[i].serviceDateTime);
      const diff = Math.abs(jobDate.getTime() - currentDate.getTime());
      if (diff < minDiff) {
        minDiff = diff;
        closest = jobs[i];
      }
    }
    return closest;
  }

  const onJobTypeChange = () => {
    form.setValue("onwardLocation", "");
    form.setValue("onwardCustomer", "");
    form.setValue("onwardCustomerName", "");
    setDestinationLocation(null);
    setOnwardSearch("");
  };

  const onBtnSubmitClicked = () => {
    if (!Array.isArray(serviceJobs) || serviceJobs?.length === 0) {
      showToast(
        "error",
        "Please add at least one job before confirming the order.",
      );
      return;
    }

    const jobs = serviceJobs?.map((sj: any) => {
      const currentDate = new Date();
      const jobDate = new Date(sj.serviceDateTime);
      jobDate.setHours(
        currentDate.getHours(),
        currentDate.getMinutes(),
        currentDate.getSeconds(),
        currentDate.getMilliseconds(),
      );
      return {
        serviceDateTime: formatDate(jobDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
        sourceSPId: sj.sourceSPId,
        onwardSPId: sj.onwardSPId,
        routeNo: sj.routeNo,
        shift: sj.shift,
        jobType: sj.jobType,
        jobNature: sj.jobNature,
        priority: sj.priority,
        containsValuables: true,
        remarks: sj.remarks,
      };
    });

    const closestObject: any = findClosestJob(jobs);

    const requestDto = {
      customerId,
      invoicingModel: serviceJobs?.[0]?.invoicingModel,
      requestedBy: serviceJobs?.[0]?.requestedBy,
      operationDate:
        closestObject?.serviceDateTime ||
        formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      jobs,
    };
    createB2BOrder(requestDto);
  };

  // result handling
  useEffect(() => {
    if (isOrderSuccess) {
      form.reset();
      orderReset();
      setDestinationLocation(null);
      setSourceLocation(null);
      setServiceJobs([]);
      setCustomerId("");
      setSearchTerm("");
      setOnwardSearch("");
    }
    if (isOrderError) {
      orderReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSuccess, isOrderError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/b2b-services">B2B</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>
              {requestId ? "Add Job" : "Create B2B Request"}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex mx-4 my-5 gap-3">
        <Card className="flex-1">
          <CardContent className="p-4">
            <Form {...form}>
              <form
                id="collection-form"
                onSubmit={form.handleSubmit(addJob)}
                className="gap-4 grid grid-cols-2"
              >
                <FormSelect
                  form={form}
                  data={invoicingModels}
                  name="invoicingModel"
                  label="Invoicing Model"
                  placeholder="Select Invoicing Model"
                />
                <FormSelect
                  form={form}
                  data={jobTypes}
                  name="jobType"
                  label="Job Type"
                  placeholder="Select Job Type"
                  onChange={onJobTypeChange}
                />
                <FormField
                  control={form.control}
                  name="sourceLocation"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Source Location</FormLabel>

                      <SearchableDropdown
                        placeholder="Search Source Location"
                        value={field.value}
                        searchTerm={searchTerm}
                        onSearchChange={setSearchTerm}
                        data={
                          sourceLocations?.map((item: any) => ({
                            value: item.servicePointId,
                            label: `${item.barcode || ""}-${item.locationId}`,
                          })) || []
                        }
                        loading={isFetchingAutocomplete}
                        onChange={(val) => {
                          field.onChange(val);
                          onSourceLocationChanged(val);
                        }}
                      />

                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="sourceCustomerName"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Source Location Customer</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          placeholder="Select Source Location"
                          readOnly
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="onwardLocation"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Onward Location</FormLabel>

                      <SearchableDropdown
                        placeholder="Search Onward Location"
                        value={field.value}
                        searchTerm={onwardSearch}
                        onSearchChange={setOnwardSearch}
                        data={
                          (isHolding ? holdingList : onwardLocations)?.map(
                            (item: any) => ({
                              value: item.servicePointId,
                              label: `${item.barcode || ""}-${item.locationId}`,
                            }),
                          ) || []
                        }
                        loading={isFetchingOnward || isFetchingHolding}
                        onChange={(val) => {
                          field.onChange(val);
                          onDestinationLocationChanged(val);
                        }}
                      />

                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="onwardCustomerName"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Onward Location Customer</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          placeholder="Select Onward Location"
                          readOnly
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="serviceDateTime"
                  render={({ field }) => (
                    <FormItem className="space-y-2">
                      <FormLabel>Service Date</FormLabel>
                      <DatePicker
                        {...field}
                        placeholder="Pick a date"
                        selectedDate={field.value}
                        onSelectDate={field.onChange}
                        disabled={(date) => date < PREV_5_DAY_DATE}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormSelect
                  form={form}
                  data={jobPriorities}
                  name="priority"
                  label="Job Priority"
                  placeholder="Select Job Priority"
                />
                <FormSelect
                  form={form}
                  data={jobNatures}
                  name="jobNature"
                  label="Job Nature"
                  placeholder="Select Job Nature"
                />

                <FormCombobox
                  form={form}
                  data={inRouteTeams?.map((m: any) => ({
                    value: String(m.routeNo),
                    label: `${m.routeNo} (${m.description})`,
                  }))}
                  name="routeNo"
                  label="Route"
                  placeholder="Select Route"
                />

                <FormField
                  control={form.control}
                  name="requestedBy"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Requested By</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          placeholder="Select Requested By"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="remarks"
                  render={({ field }) => (
                    <FormItem className="col-span-2">
                      <FormLabel>Remarks</FormLabel>
                      <FormControl>
                        <Textarea
                          placeholder="Write your remarks"
                          className="resize-none"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <div className="border-b my-3 bg-accent col-span-2" />

                <Button
                  type="button"
                  variant="outline"
                  onClick={() => {
                    form.reset();
                    setSourceLocation(null);
                    setDestinationLocation(null);
                    setSearchTerm("");
                    setOnwardSearch("");
                  }}
                  className="gap-3"
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="secondary"
                  className=" gap-3"
                  isLoading={isOrderPending}
                >
                  <ListPlus /> Add Job
                </Button>
              </form>
            </Form>
          </CardContent>
        </Card>

        <Card className="flex-1">
          <CardContent className="p-4">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Source Location</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.locationId || "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.locationName ||
                      sourceLocation?.name ||
                      "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationType ||
                      (sourceLocation?.name ? "Cash Center" : "-")}{" "}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.routeNo || "-"}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.siteLimit || "-"}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.serviceDays || "-"}
                  </div>
                </div>
              </div>

              <hr className="border-b bg-accent my-4" />

              <h5 className="text-md font-bold">Delivery Site</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationId || "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationName ||
                      destinationLocation?.name ||
                      "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationType ||
                      (destinationLocation?.name ? "Cash Center" : "-")}{" "}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.routeNo || "-"}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.siteLimit || "-"}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.serviceDays || "-"}
                  </div>
                </div>
              </div>

              <hr className="border-b bg-accent my-4" />

              {serviceJobs.length > 0 && (
                <>
                  <h5 className="text-md font-bold my-3">Jobs</h5>
                  <div className="space-y-2">
                    {serviceJobs.map((j, idx) => (
                      <div
                        key={j.requestId || j.jobNo}
                        className="p-3 border rounded-md flex justify-between items-center"
                      >
                        <div>
                          <div className="font-medium">
                            #{j.jobNo} — {j.jobType}
                          </div>
                          <div className="text-sm text-muted">
                            Nature: {j.jobNature} • Route: {j.routeNo}
                          </div>
                          <div className="text-sm text-muted">
                            From: {j.source || "-"} → To: {j.destination || "-"}
                          </div>
                          <div className="text-sm text-muted">
                            ServicePointIds: {j.sourceSPId || "-"} →{" "}
                            {j.onwardSPId || "-"}
                          </div>
                        </div>
                        <div>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => deleteJob(idx)}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {!requestId && (
                <Button
                  type="button"
                  disabled={isOrderPending || serviceJobs?.length === 0}
                  isLoading={isOrderPending}
                  variant="secondary"
                  className="w-full mt-5"
                  onClick={onBtnSubmitClicked}
                >
                  Confirm order
                </Button>
              )}
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

/* ---------- Helper components (FormSelect, FormCombobox) ---------- */

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
